import React from 'react';
import PropTypes from 'prop-types';
import styles from './Spinner.styl';
import SpinnerIcon from './SpinnerIcon';

const Spinner = ({size}) => (
  <div className={styles.Spinner}>
    <SpinnerIcon size={size} />
  </div>
);

Spinner.propTypes = {
  size: PropTypes.number,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Spinner/Spinner.js